import React from 'react'
import {
    Box,
    Flex,
    Image,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

const ProductRegistrationImageContainer = ({image, title, description, variant = 'default'}) => {
    const styles = useMultiStyleConfig('ProductRegistration', {variant})
    const intl = useIntl()
    return (
        <Flex {...styles.infoBannerContainer}>
            <Flex {...styles.infoBannerInnerContainer}>
                <Image
                    {...styles.infoImage}
                    src={image}
                    alt={intl.formatMessage({
                        id: 'product_registration_page.informative_icon',
                        defaultMessage: 'an icon showing the position of a QR code on a box',
                    })}
                />
                <Box {...styles.infoLabelContainer}>
                    <Text {...styles.infoTitle}>{title}</Text>
                    <Text {...styles.infoDescription}>{description}</Text>
                </Box>
            </Flex>
        </Flex>
    )
}

ProductRegistrationImageContainer.propTypes = {
    image: PropTypes.string,
    title: PropTypes.object,
    description: PropTypes.object,
    variant: PropTypes.string,
}

export default ProductRegistrationImageContainer
